// IOS 唤起app scheme - 均采用universal link 故 点击下载只会进入app store 不会唤起app
export const IOS_SCHEME = ''
// IOS 唤起app 商店 - 均采用universal link 故 点击下载只会进入app store 不会唤起app
export const IOS_APP_STORE = 'https://apps.apple.com/tw/app/dokimo/id6798185363'
// Android 唤起app scheme
export const ANDROID_SCHEME = ''
// Android 唤起app 商店
export const ANDROID_PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.pixelmuse.dokimo'

// 关于我们
export const ABOUT_US_URL = 'https://h5-character.dokimoai.com/help/aboutUs'
// 隐私权政策
export const PRIVACY_POLICY_URL =
  'https://h5-character.dokimoai.com/help/privacyPolicy'
// 使用者协议
export const USER_SERVICE_URL =
  'https://h5-character.dokimoai.com/help/userService'
// 退款协议
export const REFUND_AGREEMENT_URL =
  'https://h5-character.dokimoai.com/help/refundAgreement'
// 联系我们
export const CONTACT_EMAIL = 'service@dokimoai.com'

export const STAT_TYPE_SOURCE = {
  home: 'home', // 从首页流
}

// 存储的key
export const LOCAL_STORAGE_KEY_DID = 'did'
export const DOKIMO_TOKEN_KEY = 'token'
export const DOKIMO_MEMBER_INFO_KEY = 'member_info'

export const GOOGLE_WEB_CLIENT_ID =
  '377593559571-90hkla25oopgf7crrfluap5hnkjhgukq.apps.googleusercontent.com'
export const LINE_CHANNEL_ID = '2010813778'
export const X_CLIENT_ID = 'SkFDaWNuZWhHak4xY0pjUEtsOUo6MTpjaQ'
export const FACEBOOK_APP_ID = '1537593034831416'
export const APPLE_SERVICES_ID = 'com.pixelmuse.dokimo.web'

export const OPEN_TYPE = {
  facebook: 5,
  google: 6,
  line: 8,
  x: 9,
  apple: 13,
} as const

export const DELETE_ACCOUNT_PATH = '/delete-account'
export const RECHARGE_PATH = '/recharge'
/* 官网储值白名单已停用，保留名单供后续参考。
export const RECHARGE_MEMBER_ID_WHITELIST = new Set<number>([
  131072, 131081, 132046, 138814, 285408291, 285408302, 302127545, 302129174,
  302131138, 302131861, 302131902, 302133342, 302135363, 302139476, 302139477,
  302139478, 302139479, 302139480, 302139481, 302139482, 302139483, 302139484,
  302139485, 302139486, 302139487, 302139488, 302139489, 302139490, 302139491,
  302139492, 302139493, 302139494, 302139495, 302139496, 302139497, 302139498,
  302139499, 302139500, 302139501, 302139502, 302139503, 302139504, 302139505,
  302139506, 302139507, 302139508, 302139509, 302139510, 302139511, 302139512,
  302139513, 302139514, 302139515, 302139516, 302139517, 302139518, 302139519,
  302139520, 302139521, 302139522, 302139523, 302139524, 302139525, 302139526,
  302139527, 302139528, 302139529, 302139530, 302139531, 302139532, 302139533,
  302139534, 302139535, 302139536, 302139537, 302139538, 302139539, 302139540,
  302139541, 302139542, 302139543, 302139544, 302139545, 302139546, 302139547,
  302139548, 302139549, 302139550, 302139551, 302139552, 302139553, 302139554,
  302139555, 302139556, 302139557, 302139558, 302139559, 302139560, 302139561,
  302139562, 302139563, 302139564, 302139565, 302139566, 302139567, 302139568,
  302139569, 302139570, 302139571, 302139572, 302139573, 302139574, 302139575,
])
*/

export const LINE_CALLBACK_PATH = '/line/callback'
export const APPLE_CALLBACK_PATH = '/apple/callback'
export const X_CALLBACK_PATH = '/x/callback'

// 显示头部的路径映射
export const SHOW_HEADER_MAP = {
  '/': true,
  [RECHARGE_PATH]: false,
  '/rechargeAgreement': false,
  [LINE_CALLBACK_PATH]: false,
  [APPLE_CALLBACK_PATH]: false,
  [X_CALLBACK_PATH]: false,
}
// 显示底部的路径映射
export const SHOW_FOOTER_MAP = {
  '/': true,
  [RECHARGE_PATH]: false,
  '/rechargeAgreement': false,
}
// 显示主页面的背景映射
export const SHOW_HOME_BG_MAP = {
  '/': true,
  [DELETE_ACCOUNT_PATH]: false,
  [RECHARGE_PATH]: false,
  '/rechargeAgreement': false,
}
// 移动端断点
export const MOBILE_BREAKPOINT = 768
// 窗口大小变化节流延迟时间
export const RESIZE_THROTTLE_DELAY = 200

// 首页背景图 - WEB
export const IMG_HOME_WEB_BG =
  'https://bd-xc-web.ixiaochuan.cn/zuiyou/3977942a_1j8pstooa_6_.png'
// 首页背景图 - MOBILE
export const IMG_HOME_MOBILE_BG =
  'https://bd-xc-web.ixiaochuan.cn/zuiyou/958187cb_1j8q849ku_1_.png'
